import { z } from 'zod';

export const createUserSchema = z
    .object({
        name: z.string().min(1, 'Name is required').max(255),
        email: z.string().email('Invalid email').max(255),
        mfa_enforced: z.boolean().default(false),
        dealer_id: z.string().uuid().nullable().optional(),
        organisation_id: z.string().uuid().nullable().optional(),
    })
    .refine((d) => !(d.dealer_id && d.organisation_id), {
        message: 'A user can have a dealer or an organisation association, not both.',
        path: ['dealer_id'],
    });

export const updateUserSchema = z.object({
    name: z.string().min(1).max(255).optional(),
    email: z.string().email().max(255).optional(),
});

export const associationSchema = z
    .object({
        dealer_id: z.string().uuid().nullable().optional(),
        organisation_id: z.string().uuid().nullable().optional(),
    })
    .refine((d) => !(d.dealer_id && d.organisation_id), {
        message: 'Cannot have both dealer and organisation association',
        path: ['dealer_id'],
    });

export const mfaEnforcementSchema = z.object({
    enforce: z.boolean(),
});

export const releaseEmailSchema = z.object({
    confirmation: z.literal('I understand this releases the email for reuse', {
        errorMap: () => ({ message: 'You must type the confirmation phrase exactly' }),
    }),
});

export type CreateUserFormInputs = z.infer<typeof createUserSchema>;
export type UpdateUserFormInputs = z.infer<typeof updateUserSchema>;
export type AssociationFormInputs = z.infer<typeof associationSchema>;
export type MfaEnforcementFormInputs = z.infer<typeof mfaEnforcementSchema>;
export type ReleaseEmailFormInputs = z.infer<typeof releaseEmailSchema>;
